/* Enhance the original pans form without replacing its template or native fallback. */
(() => {
  if (window.noLayerProductCartReady) return;
  window.noLayerProductCartReady = true;
  const pending = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches?.('form.taima-add-to-cart-form')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.renderContents || !window.routes?.cart_add_url) return;
    event.preventDefault();
    if (pending.has(form)) return;
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;

    const data = new FormData(form);
    if (!data.get('id')) return;
    const sections = drawer.getSectionsToRender().map((section) => section.id);
    data.set('sections', sections.join(','));
    data.set('sections_url', window.location.pathname);
    pending.add(form);
    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    let message = form.querySelector('.nl-cart-message');
    if (!message) {
      message = document.createElement('p');
      message.className = 'nl-cart-message';
      message.setAttribute('role', 'status');
      form.append(message);
    }
    message.replaceChildren();
    message.hidden = true;
    const showCartLink = (text) => {
      message.textContent = text + ' ';
      const link = document.createElement('a');
      link.href = window.routes.cart_url;
      link.textContent = 'View your cart';
      message.append(link);
      message.hidden = false;
    };

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        message.textContent = typeof result.description === 'string'
          ? result.description : 'We could not add this item. Please check your selected option.';
        message.hidden = false;
        return;
      }
      // A successful add is never retried when section rendering fails.
      if (!sections.every((id) => typeof result.sections?.[id] === 'string')) {
        showCartLink('Added.');
        return;
      }
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(button);
      try {
        drawer.renderContents(result);
      } catch (_) {
        showCartLink('Added.');
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'nolayer-product-form', productVariantId: data.get('id'), cartData: result,
        })).catch(() => {});
      }
      document.dispatchEvent(new CustomEvent('nolayer:cart-updated'));
    } catch (_) {
      // The server may have accepted the request. Do not automatically add again.
      showCartLink('We could not load the confirmation. Please check your cart before trying again.');
    } finally {
      pending.delete(form);
      button.removeAttribute('aria-busy');
      // A variant change during the request owns the new availability/label.
      if (new FormData(form).get('id') === data.get('id')) {
        button.disabled = false;
        button.textContent = label;
      }
    }
  });
})();
